import { render } from "./PanelTop.vue?vue&type=template&id=3ba12ef6&scoped=true&ts=true"
import script from "./PanelTop.vue?vue&type=script&lang=ts"
export * from "./PanelTop.vue?vue&type=script&lang=ts"

import "./PanelTop.vue?vue&type=style&index=0&id=3ba12ef6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba12ef6"]])

export default __exports__